<section class="history-section section-padding" aria-labelledby="history-title" itemscope
  itemtype="https://schema.org/Organization">
  <div class="history-bg-accent" aria-hidden="true"></div>

  <div class="container history-grid">

    <!-- Bloque de Texto -->
    <div class="history-content">
      <span class="section-subtitle">Nuestras Raíces</span>

      <h2 id="history-title">
        <span itemprop="name" class="visually-hidden">Estancos Distilling Company</span>
        Forjados en las Alturas de los Andes
      </h2>

      <!-- AEO: Párrafos redactados en formato de Tripletas Semánticas puras -->
      <p itemprop="description">
        <strong>Estancos Distilling Company</strong> desafía las convenciones de la destilación tradicional. Nuestra
        marca forja caracteres excepcionales utilizando las condiciones extremas de los Andes.
      </p>
      <p>
        <strong>Nuestra destilería</strong> madura sus licores a <strong>2500 metros sobre el nivel del mar</strong>. En
        esta altitud, <strong>el clima extremo</strong> acelera la extracción de sabores dentro de nuestras barricas de
        roble. Este <strong>envejecimiento dinámico</strong> crea un perfil inconfundible con notas a madera tostada y
        sutiles toques especiados.
      </p>

      <blockquote class="quote-box" aria-label="Filosofía de destilación">
        <p class="quote-text">"No solo hacemos destilados; destilamos la esencia de nuestra cordillera."</p>
        <footer class="quote-author">
          — <cite itemprop="founder">Richard Armendariz</cite>, Maestro Destilador de Estancos Distilling Company
        </footer>
      </blockquote>
    </div>

    <!-- Bloque Visual -->
    <div class="history-visuals">
      <div class="visual-accent" aria-hidden="true"></div>
      <img src="https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/RichardMaster.jpeg"
        alt="Richard Armendariz, Maestro Destilador de Estancos Distilling Company a 2500 metros de altura"
        class="image-main" itemprop="image" loading="lazy" width="480" height="640" ngSkipOversizedImageWarning>
    </div>

  </div>
</section>